// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3F4Vb","active":"NavigationItem_active__2akpn"};